import React, { JSX, ReactNode } from 'react';
import { Heading, ThemeColors } from '@feast-it/ui/light';
import { useIsDarkTheme } from '../../context/DarkThemeContext';
import {
  Container,
  DescriptionWrapper,
  Inner,
  TextWrapper,
} from './SliceLayout.styled';

export interface SliceLayoutProps {
  backgroundColor: keyof ThemeColors;
  headingOptions?: {
    titleText: string;
    descriptionText?: string;
    color?: keyof ThemeColors;
  };
  children: ReactNode;
  as?: keyof JSX.IntrinsicElements;
}

export function SliceLayout({
  backgroundColor,
  headingOptions,
  children,
  as = 'section',
}: SliceLayoutProps) {
  const isDark = useIsDarkTheme();
  const headingColor = isDark ? 'white' : headingOptions?.color ?? 'black';

  return (
    <Container as={as} backgroundColor={backgroundColor} isDark={isDark}>
      <Inner>
        {headingOptions && (
          <TextWrapper>
            {headingOptions.titleText && (
              <Heading
                as="h2"
                style="headingJumbo"
                color={headingColor}
                fluidTypographyOptions={{
                  minPx: 32,
                  maxPx: 60,
                  viewportWidth: 4,
                }}
              >
                {headingOptions.titleText}
              </Heading>
            )}

            {headingOptions.descriptionText && (
              <DescriptionWrapper color={headingColor} isDark={isDark}>
                {headingOptions.descriptionText}
              </DescriptionWrapper>
            )}
          </TextWrapper>
        )}

        {children}
      </Inner>
    </Container>
  );
}
